import { AxiosResponse } from 'axios';
import HttpClient from '../utils/HttpClientHandler';
import { Feature, NewFeature } from '../types/Feature';

const FeatureService = class FeatureService {
    #baseURL: string;

    constructor() {
        this.#baseURL = '/dashboard/feature';
    }

    public async getAllFeatures(): Promise<Feature[]> {
        const response: AxiosResponse = await HttpClient.get(this.#baseURL);
        const { data }: { data: Feature[] } = response;
        return data;
    }

    public async getFeatureByName(featureName: string): Promise<Feature | undefined> {
        const response: AxiosResponse = await HttpClient.get(this.#baseURL);
        const { data }: { data: Feature[] } = response;
        const feature: Feature | undefined = data.find((ft) => ft.name === featureName);
        return feature;
    }

    public async createFeature(newFeatureData: NewFeature): Promise<NewFeature> {
        const response: AxiosResponse = await HttpClient.post(this.#baseURL, newFeatureData);
        const { data }: { data: NewFeature } = response;
        return data;
    }
};

export default new FeatureService();
